<div class="pd-container">
  <div class="pd-header">
    <div class="pd-header-top">
      <h2 class="pd-employee-name">{{ data.employeeName }}</h2>
      <button class="lm-dialog-close-circle" (click)="close()">
        <mat-icon>{{ 'leave_management.preview_details_dialog.close' | transloco }}</mat-icon>
      </button>
    </div>

    <div class="pd-header-actions">
      <div class="pd-badge">
        {{ isCompOff ? 'Comp Off Days' : 'Optional Holidays' }}
      </div>
      @if (isOptional) {
      <button class="pd-filter-btn">
        {{ 'leave_management.preview_details_dialog.filter_by' | transloco }} <mat-icon>{{ 'leave_management.preview_details_dialog.filter_list' | transloco }}</mat-icon>
      </button>
      }
    </div>
  </div>

  @if (isCompOff) {
  <div class="pd-compoff-banner">
    Total Compensatory off Balance: {{ data.balance }}
  </div>
  }

  <div class="pd-body">
    @if (isOptional) {
    <table class="pd-table">
      <thead>
        <tr><th>{{ 'leave_management.preview_details_dialog.holiday_name' | transloco }}</th><th>{{ 'leave_management.preview_details_dialog.date' | transloco }}</th><th>{{ 'leave_management.preview_details_dialog.day' | transloco }}</th><th>{{ 'leave_management.preview_details_dialog.type' | transloco }}</th></tr>
      </thead>
      <tbody>
        @for (item of data.items; track item.name) {
        <tr>
          <td>{{ item.name }}</td><td>{{ item.date }}</td><td>{{ item.day }}</td><td>{{ item.type || 'Optional' }}</td>
        </tr>
        }
      </tbody>
    </table>
    }

    @if (isCompOff) {
    <table class="pd-table">
      <thead>
        <tr>
          <th>{{ 'leave_management.preview_details_dialog.date_of_worked' | transloco }}</th><th>{{ 'leave_management.preview_details_dialog.requested_date' | transloco }}</th>
          <th>{{ 'leave_management.preview_details_dialog.duration' | transloco }}</th><th>{{ 'leave_management.preview_details_dialog.status' | transloco }}</th><th class="pd-action-col"></th>
        </tr>
      </thead>
      <tbody>
        @for (item of data.items; track item.workDate) {
        <tr>
          <td>{{ item.workDate }}</td>
          <td>{{ item.reqDate || '-' }}</td>
          <td>{{ item.duration || '-' }}</td>
          <td>
            <div class="pd-status" [ngClass]="item.status?.toLowerCase()">
              {{ item.status }}
              @if (item.status === 'Pending') { <mat-icon class="pd-status-icon">{{ 'leave_management.preview_details_dialog.schedule' | transloco }}</mat-icon> }
              @if (item.status === 'Approved') { <mat-icon class="pd-status-icon">{{ 'leave_management.preview_details_dialog.check_circle' | transloco }}</mat-icon> }
            </div>
          </td>
          <td class="pd-action-col">
            <button class="pd-icon-btn"><mat-icon>{{ 'leave_management.preview_details_dialog.description' | transloco }}</mat-icon></button>
          </td>
        </tr>
        }
      </tbody>
    </table>
    }
  </div>

  @if (isOptional && data.note) {
  <div class="pd-footer">
    <span class="pd-note-label">{{ 'leave_management.preview_details_dialog.note' | transloco }}</span>
    <span class="pd-note-text">{{ data.note }}</span>
  </div>
  }
</div>